(function () {
    const inputs = Array.from(document.querySelectorAll('[data-quickshop] input'));
    inputs.forEach(element => element.addEventListener('change', onChange));
    inputs.forEach(element => element.addEventListener('input', onChange));

    function init() {
        const inputs = Array.from(document.querySelectorAll('[data-card-mobile-popup] input'));
        inputs.forEach(element => element.addEventListener('change', onChange));
    }

    function onChange(event) {
        const input = event.target;
        const root = input.closest('[data-quickshop]');
        const data = JSON.parse(root.querySelector('[data-variant-description-app="data"]').innerHTML);
        const descriptionElement = root.querySelector('[data-variant-description-app="custom description"]');
        const selectedId = root.querySelector('[name="id"]').value;
        const description = data.variants[selectedId] || '';

        descriptionElement.innerHTML = description;
    }

    function observeCardMobilePopupChanges(callback) {
        const target = document.querySelector('[data-card-mobile-popup]');
        if (!target) {
            console.warn('Element with [data-card-mobile-popup] not found.');
            return;
        }

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    callback(mutation);
                    break; // Fire only once per mutation batch
                }
            }
        });

        observer.observe(target, {
            childList: true, // watch for children being added or removed
            subtree: true   // watch deeper descendants
        });
        
        return observer; // optional: return observer in case you want to disconnect later
    }

    observeCardMobilePopupChanges((mutation) => {
        init();
    });

    
})()